import {
  DialogTitle,
  Grid,
  IconButton,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core'
import i18n from 'i18next'
import CloseIcon from 'mdi-react/CloseIcon'
//import { FC } from 'react'

const styles = ({ breakpoints, spacing }: Theme) => ({
  dialog: {
    padding: '16px 16px 0 24px'
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    color: '#7B8189',
    fontSize: '0.8rem',
    'text-transform': 'uppercase'
  },
  button: {
    padding: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  image: {
    width: '15px',
    margin: '5px'
  }
})
interface TitleWithCloseButton extends WithStyles {
  t: i18n.TFunction
  title: string
  closeAction: any
  hideCloseIcon?: boolean
  customCloseIcon?: any
  onClose?: () => void
}

const TitleWithCloseButton = ({
  title,
  t,
  closeAction,
  hideCloseIcon,
  classes,
  customCloseIcon,
  onClose
}: TitleWithCloseButton) => (
  <DialogTitle id='title-with-close' className={classes.dialog}>
    <Grid container className={classes.container}>
      <Grid item className={classes.title}>
        {title}
      </Grid>
      <Grid item>
        {!hideCloseIcon && (
          <IconButton
            aria-label={t('general.close')}
            onClick={() => {
              if (onClose) {
                onClose();
              }
              closeAction();
            }}
            className={classes.button}
          >
            {customCloseIcon ? (
              <img className={classes.image} src={customCloseIcon} />
            ) : (
              <CloseIcon />
            )}
          </IconButton>
        )}
      </Grid>
    </Grid>
  </DialogTitle>
)

export default withStyles(styles)(TitleWithCloseButton) as any
